import React from 'react';
import { useGcsStore } from '../../../store/useGcsStore';
import LogsCard from '../../../components/general/LogsCard';
import type { MissionId, MissionLogMessageNotification } from '../../../types/gcs/mission';

interface MissionLogsCardProps {
  gcsId: string;
  missionId: MissionId;
  title?: string;
}

const EMPTY_LOGS: MissionLogMessageNotification[] = [];

export const MissionLogsCard: React.FC<MissionLogsCardProps> = ({ gcsId, missionId, title }) => {
  const missionLogs = useGcsStore((state) => {
    const gcsData = state.data.get(gcsId);
    if (!gcsData) return EMPTY_LOGS;
    return gcsData.missionLogMessagesMap.get(missionId) ?? EMPTY_LOGS;
  });

  return <LogsCard title={title} logs={missionLogs} />;
};
